// extracted by mini-css-extract-plugin
export default {"copy":"x_-z","sizingCopy":"y_-z","recommendedFitText":"z_-z"};